import $ from 'zepto';
import { onDocumentReady, expose } from '../../main';
import FileUploader from './fileUploader';
import {
  fileUploaderInputSelector,
  fileUploaderNotEnhacedClass,
  fileUploaderNotEnhacedSelector,
} from '../../utils/constants/classes';

const $body = $(document.body);
export const fileUploaders = {};

export const getFilesById = (id) => {
  if (!id) {
    return null;
  }

  const fileUploaderInstance = fileUploaders[id];
  return fileUploaderInstance ? fileUploaderInstance.getFiles() : [];
};

export const initFileUploader = ($context = $body) => {
  const $fileUploaderInputElement = $context.find(fileUploaderInputSelector);

  $(fileUploaderNotEnhacedSelector).removeClass(fileUploaderNotEnhacedClass);

  $fileUploaderInputElement.each((index, inputElement) => {
    const $inputElement = $(inputElement);
    const fileUploaderId = $inputElement.attr('id');
    fileUploaders[fileUploaderId] = new FileUploader({ id: fileUploaderId });
    fileUploaders[fileUploaderId].initInputFile($inputElement);
  });

  expose({ getFilesById });
};

onDocumentReady('FileUploader', () => {
  initFileUploader();
});
